import type {WorkAmounts} from '@api';
import {useGetShortMonthNameWithDay, useGetWeekdayName} from '.';
import type {WorkWeek} from '../types/activity-tracker.types';

export function useDivideMonthIntoWeeks(workAmounts?: WorkAmounts[]): WorkWeek[][] {
    if (!workAmounts || workAmounts.length === 0) {
        return [];
    }

    const workAmountsMap = new Map<string, WorkAmounts>();
    workAmounts.forEach((workAmount: WorkAmounts) => {
        const dateStr = workAmount.workedDate.toISOString().split('T')[0];
        workAmountsMap.set(dateStr, workAmount);
    });

    const date = new Date(workAmounts[0].workedDate);
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const weeks: WorkWeek[][] = [];
    let week: WorkWeek[] = [];

    for (let day = 1; day <= new Date(Date.UTC(year, month + 1, 0)).getUTCDate(); day++) {
        const currentDate = new Date(Date.UTC(year, month, day));
        const weekday = useGetWeekdayName(currentDate);
        const formattedDate = useGetShortMonthNameWithDay(currentDate);
        const currentDateStr = currentDate.toISOString().split('T')[0];
        const workAmountEntry = workAmountsMap.get(currentDateStr);

        let workAmount = 0;

        if (workAmountEntry) {
            workAmount = workAmountEntry.workAmount;
        }

        week.push({
            weekday,
            date: formattedDate,
            workAmount,
        });

        if (currentDate.getUTCDay() === 0 || day === new Date(Date.UTC(year, month + 1, 0)).getUTCDate()) {
            weeks.push(week);
            week = [];
        }
    }

    return weeks;
}
